export default {
  InputEmpty: "por favor ingrese {name}",
} as const;
